import { useEffect } from 'react';
import { Row, Col, Card } from 'react-bootstrap';

// import AppNavbar from '../Navbar/AppNavbar';
import AppLayout from '../Navbar/AppLayout';
import '../../assets/css/dashboard.scss';
import { Tabs, Tab } from 'react-bootstrap';
import RecentActivities from './RecentActivities';
import DonutChart from './DonutChart';
import RecentSearchTable from './RecentSearchTable';
import WorldMapChart from './WorldMapChart';
import Footer from '../Navbar/Footer';
import { useDispatch, useSelector } from 'react-redux';
import { getAllUploads, loadCountryGraph, loadDashboardCountryGraph, loadIndustryGraph, loadDashboardIndustryGraph, loadloginDetails, loadRecentSearch, loadSubscriptions, fetchTotalCounts, loadUserActivityData, loadUserDownloadData } from '../redux/action';
import SubscriptionDetails from './SubscriptionDetails';
import { Skeleton } from '@mui/material';
import UploadStatsBarChart from './UploadStatsBarChart';
import totalIcon from '../../assets/images/dashboard/multiple-users.png';
import countryIcon from '../../assets/images/dashboard/globe.png';
import industryIcon from '../../assets/images/dashboard/industries.png';
import jobIcon from '../../assets/images/dashboard/jobtitle.png';
import techIcon from '../../assets/images/dashboard/technology.png';
import NoDataImg from "../../assets/images/No data-found.svg"; 
import RaiseRequest from '../Request/RaiseRequest';
import { useNavigate } from "react-router-dom";



const Dashboard = () => {
    const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails"));
    console.log(signInDetails,'signInDetails')
    const user_role = signInDetails[0]?.role.toLowerCase();
    const navigate = useNavigate();


    const dispatch = useDispatch();
    const { total_counts_userwise } = useSelector(state => state.data);
    const icons = [
        totalIcon, 
        countryIcon, 
        industryIcon, 
        jobIcon, 
        techIcon
    ];
    
    const {
  user_sessions_data,
  user_download_data,
  user_upload_data,
  user_activity_data
} = useSelector(state => state.data);

    useEffect(() => {
        dispatch(fetchTotalCounts());
        // dispatch(loadTotalCountsUserwise());
        dispatch(loadSubscriptions());
        dispatch(loadloginDetails());
        dispatch(getAllUploads(1,20,signInDetails[0]?.role,signInDetails[0]?.sbn_id,signInDetails[0]?.id,[]));
        dispatch(loadUserActivityData());
        dispatch(loadUserDownloadData());
        
        dispatch(loadRecentSearch());
        dispatch(loadDashboardCountryGraph(signInDetails[0]?.id));
dispatch(loadDashboardCountryGraph(signInDetails[0]?.id, "map"));
        // dispatch(loadDashboardCountryGraph());
        // dispatch(loadDashboardCountryGraph("map"));
        // dispatch(loadCountryGraph());
        // dispatch(loadCountryGraph("map"));
        // dispatch(loadIndustryGraph());
        dispatch(loadDashboardIndustryGraph(signInDetails[0]?.id));
        
        const tokendata = decodeResetToken("Hgw1HhIeD3FZUUhnclVbDQQzXhAYCSNZVUtqAgUFXFxuQktDUw==")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    

    function decodeResetToken(token, secretKey = 'lm_pswd_key_226') {
        try {
            // 1. Base64 decode to binary string
            const decodedBinary = atob(token);

            // 2. XOR decrypt into a Uint8Array
            const decryptedBytes = new Uint8Array(decodedBinary.length);
            for (let i = 0; i < decodedBinary.length; i++) {
                const keyChar = secretKey.charCodeAt(i % secretKey.length);
                decryptedBytes[i] = decodedBinary.charCodeAt(i) ^ keyChar;
            }

            // 3. Decode UTF-8 bytes to string
            const decoder = new TextDecoder('utf-8');
            const decrypted = decoder.decode(decryptedBytes);

            // 4. Expect format: email|YYYYMMDDHHMMSS
            const [email, timestamp] = decrypted.split('|');

            if (!email || !timestamp || timestamp.length !== 14) {
                throw new Error("Invalid format");
            }

            // 5. Parse timestamp
            const year = parseInt(timestamp.slice(0, 4));
            const month = parseInt(timestamp.slice(4, 6)) - 1;
            const day = parseInt(timestamp.slice(6, 8));
            const hour = parseInt(timestamp.slice(8, 10));
            const minute = parseInt(timestamp.slice(10, 12));
            const second = parseInt(timestamp.slice(12, 14));

            const expiryDate = new Date(year, month, day, hour, minute, second);
            const now = new Date();

            return {
                email,
                expiryDate,
                isExpired: now > expiryDate
            };
        } catch (error) {
            return {
                error: 'Invalid or corrupted token',
                details: error.message
            };
        }
    }


    return (
        <div className='page-layout'>
            {/* <AppNavbar /> */}
            <AppLayout>
                <div className='page-content' style={{ overflow: "auto" }}>
                    <div className='dashboard-container'>
                        {/* <Row className='p-3 m-0'>
                          {get_total_couts.length !== 0 ? (
                            <>
                              {Array.from({ length: 5 }).map((_, index) => {
                                const item = get_total_couts[index];
                                return (
                                  <Col key={index}>
                                    <Card className="p-3 dashboard-count-card">
                                      {item ? (
                                        <>
                                          <div>
                                            <small className="text-muted count-header">{item.title}</small>
                                            <h5 className="fw-bold mb-0">{item.count}</h5>
                                            <h5 className="fw-bold mb-0">
  {user_role === "client" && item?.title?.toLowerCase() === "client login"
    ? 0
    : (item?.count ?? 0)}
</h5>
                                          </div>
                                          
                                          <img
                                            src={icons[index % icons.length]}
                                            alt={item.title}
                                            className='dashboard-card-image'
                                          />
                                        </>
                                      ) : (
                                        <div style={{ height: "70px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                          <Skeleton width="80%" height={30} />
                                        </div>
                                      )}
                                    </Card>
                                  </Col>
                                );
                              })}
                            </>
                          ) : (
                            <>
                              {Array.from({ length: 5 }).map((_, index) => (
                                <Col key={index} style={{ height: "100px" }}>
                                  <Skeleton className="custom_skeleton" />
                                </Col>
                              ))}
                            </>
                          )}
                        </Row> */}

                        <Row className="p-3 m-0">
  {(Array.isArray(total_counts_userwise) && total_counts_userwise.length === 5)
    ? total_counts_userwise.map((item, index) => (
        <Col key={index}>
          <Card
            className={`p-3 dashboard-count-card ${
              index === 0 ? "clickable-card" : ""
            }`}
            onClick={() => {
              if (index === 0) {
                navigate("/contact-filter");
              }
            }}
          >
            <div>
              <small className="text-muted count-header">
                {item.title}
              </small>

              <h5 className="fw-bold mb-0">
                {[ "b2buser", "bde"].includes(user_role || "")
                  ? 0
                  : (item.count ?? 0)}
              </h5>
            </div>

            <img
              src={icons[index]}
              alt={item.title}
              className="dashboard-card-image"
            />
          </Card>
        </Col>
      ))
    : Array.from({ length: 5 }).map((_, index) => (
        <Col key={index} style={{ height: "100px" }}>
          <Skeleton className="custom_skeleton" />
        </Col>
      ))}
</Row>


            {/* <Row className="p-3 m-0">
  {(Array.isArray(total_counts_userwise) && total_counts_userwise.length === 5)
    ? total_counts_userwise.map((item, index) => (
        <Col key={index}>
          <Card className="p-3 dashboard-count-card">

            <div>
              <small className="text-muted count-header">
                {item.title}
              </small>

              <h5 className="fw-bold mb-0">
                {[ "b2buser", "bde"].includes(user_role || "")
                  ? 0
                  : (item.count ?? 0)}
              </h5>
            </div>

            <img
              src={icons[index]}
              alt={item.title}
              className="dashboard-card-image"
            />
          </Card>
        </Col>
      ))
    : Array.from({ length: 5 }).map((_, index) => (
        <Col key={index} style={{ height: "100px" }}>
          <Skeleton className="custom_skeleton" />
        </Col>
      ))}
</Row> */}


                        {user_role === "super_admin" && <Row className='p-3 m-0 dashboard-subscription-container'>
                            {/* {user_role === "super_admin" &&  */}
                            <Col md={6}>
                                <SubscriptionDetails />
                            </Col>
                            {/* } */}
                            {/* {user_role === "super_admin" &&  */}
                            <Col md={6}><UploadStatsBarChart /></Col>
                            {/* } */}
                        </Row>}
                        
                        {/* {user_role === "client" && ( */}
                        {["client", "b2buser", "bde"].includes(user_role) && (
  <Row className='p-3 donut-chart-row'>
    <Col md={6} className='donut-chart-col'>
      <DonutChart />
    </Col>
    <Col md={6} className='recent-search-table-col requestPage'>
      <RaiseRequest hideLayout={true} showLatestOnly={true}/>
    </Col>
  </Row>
)}

                        

                        <Row className='world-map-row  dashboard-subscription-container'>
  <Col md={6} className='world-map-col'>
    <div className='world-map-container'>
      <WorldMapChart />
    </div>
  </Col>

  <Col md={6}>
    <Card className='dashboard-subscription-card'>
      <div className='dashboard-subscription-card-header'>
        <h5>Recent Activities</h5>
      </div>

      <Card.Body>
        <Tabs 
          defaultActiveKey={user_role === "super_admin" ? "sessions" : "downloads"} 
          id="recent-activities-tabs" 
          className="mb-3 miui-tabs"
        >

          {user_role === "super_admin" && (
            <Tab eventKey="sessions" title="Sessions">
              {user_sessions_data?.length > 0 ? (
                <RecentActivities type="sessions" />
              ) : (
                <div className="text-center py-4">
                  <img src={NoDataImg} style={{ width: "240px", opacity: 0.8 }} alt="" />
                  <p className="mt-2 text-muted">No Sessions Found</p>
                </div>
              )}
            </Tab>
          )}

          <Tab eventKey="downloads" title="Downloads">
            {user_download_data?.length > 0 ? (
              <RecentActivities type="downloads" />
            ) : (
              <div className="text-center py-4">
                <img src={NoDataImg} style={{ width: "240px", opacity: 0.8 }} alt="" />
                <p className="mt-2 text-muted">No Downloads Found</p>
              </div>
            )}
          </Tab>

          {user_role === "super_admin" && (
            <Tab eventKey="upload" title="Upload">
              {user_upload_data?.length > 0 ? (
                <RecentActivities type="upload" />
              ) : (
                <div className="text-center py-4">
                  <img src={NoDataImg} style={{ width: "240px", opacity: 0.8 }} alt="" />
                  <p className="mt-2 text-muted">No Uploads Found</p>
                </div>
              )}
            </Tab>
          )}

          {user_role === "client" && (
            <Tab eventKey="activities" title="Activities">
              {user_activity_data?.length > 0 ? (
                <RecentActivities type="activities" />
              ) : (
                <div className="text-center py-4">
                  <img src={NoDataImg} style={{ width: "240px", opacity: 0.8 }} alt="" />
                  <p className="mt-2 text-muted">No Activities Found</p>
                </div>
              )}
            </Tab>
          )}

        </Tabs>
      </Card.Body>
    </Card>
  </Col>
</Row>

                    </div>
                    <Footer />
                </div>
            </AppLayout>
        </div>
    );
};

export default Dashboard;
